module.exports = __webpack_public_path__ + "static/media/IMG-7.8e5803bc.jpg";